import { Schedules } from '../types';

import { axios } from '@/lib/axios';
import { OutputErrorLog } from '@/lib/error';

// スケジュールAPI
export const getSchedules = async (
  siteId: number,
  options?: {
    measurementDate?: string;
    baseDate?: string;
  }
): Promise<Schedules | null> => {
  try {
    const result = await axios.get<Schedules>(`/sites/${siteId}/schedules`, {
      params: {
        measurementDate: options?.measurementDate,
        baseDate: options?.baseDate,
      },
    });
    return result.data;
  } catch (error) {
    OutputErrorLog('getSchedules', error);
    return null;
  }
};
